import { render, staticRenderFns } from "./Seo2.vue?vue&type=template&id=c0e0b29c&scoped=true&"
import script from "./Seo2.vue?vue&type=script&lang=js&"
export * from "./Seo2.vue?vue&type=script&lang=js&"
import style0 from "./Seo2.vue?vue&type=style&index=0&id=c0e0b29c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e0b29c",
  null
  
)

export default component.exports